import * as React from "react"
import type { SVGProps } from "react"
const SvgSave = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 21.86q-.82 0-1.41-.59A2 2 0 0 1 3 19.86v-14q0-.82.59-1.42A2 2 0 0 1 5 3.86h11.18a2 2 0 0 1 1.4.57l2.85 2.85a2 2 0 0 1 .57 1.4v11.18q0 .83-.59 1.41a2 2 0 0 1-1.41.59zM19 8.7l-2.85-2.85H5v14h14zm-7 10.15q1.25 0 2.13-.88a3 3 0 0 0 .87-2.12q0-1.25-.87-2.13a3 3 0 0 0-2.13-.87q-1.25 0-2.12.87A3 3 0 0 0 9 15.86q0 1.25.88 2.12a3 3 0 0 0 2.12.88m-5-8h7q.42 0 .71-.29a1 1 0 0 0 .29-.71v-2a1 1 0 0 0-.29-.72 1 1 0 0 0-.71-.28H7a1 1 0 0 0-.71.28 1 1 0 0 0-.29.72v2q0 .42.29.71.29.3.71.29" />
  </svg>
)
export default SvgSave
